/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicProgram', 'model/StrategicProgramReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategicProgram'), require('../model/StrategicProgramReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicProgramApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicProgram, root.ForStractionServiceApi.StrategicProgramReport);
  }
}(this, function(ApiClient, StrategicProgram, StrategicProgramReport) {
  'use strict';

  /**
   * StrategicProgram service.
   * @module api/StrategicProgramApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategicProgramApi. 
   * @alias module:api/StrategicProgramApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategicProgramAddAllPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicProgram>} body 
     * @param {module:api/StrategicProgramApi~strategicProgramAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.strategicProgramAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StrategicProgram/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramAddPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgram} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.sendNotificationToOwner  (default to false)
     * @param {module:api/StrategicProgramApi~strategicProgramAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategicProgramAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sendNotificationToOwner': opts['sendNotificationToOwner']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategicProgram/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramDeleteGet operation.
     * @callback module:api/StrategicProgramApi~strategicProgramDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/StrategicProgramApi~strategicProgramDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling strategicProgramDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgram/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramEditAllPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicProgram>} body 
     * @param {module:api/StrategicProgramApi~strategicProgramEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgram/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramEditAndCloseProgramPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramEditAndCloseProgramPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAndCloseProgram
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgram} body 
     * @param {module:api/StrategicProgramApi~strategicProgramEditAndCloseProgramPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramEditAndCloseProgramPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramEditAndCloseProgramPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramEditAndCloseProgramPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgram/editAndCloseProgram', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramEditPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgram} body 
     * @param {module:api/StrategicProgramApi~strategicProgramEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgram/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramLoadAllGet operation.
     * @callback module:api/StrategicProgramApi~strategicProgramLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicProgramReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {Integer} opts.includeDataActuals  (default to 0)
     * @param {module:api/StrategicProgramApi~strategicProgramLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicProgramReport>}
     */
    this.strategicProgramLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount'],
        'includeDataActuals': opts['includeDataActuals']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicProgramReport];

      return this.apiClient.callApi(
        '/StrategicProgram/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramLoadGet operation.
     * @callback module:api/StrategicProgramApi~strategicProgramLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicProgramReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} programID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {module:api/StrategicProgramApi~strategicProgramLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicProgramReport}
     */
    this.strategicProgramLoadGet = function(_4SAPIAppID, programID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramLoadGet";
      }

      // verify the required parameter 'programID' is set
      if (programID == undefined || programID == null) {
        throw "Missing the required parameter 'programID' when calling strategicProgramLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'programID': programID,
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicProgramReport;

      return this.apiClient.callApi(
        '/StrategicProgram/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramLoadManyPut operation.
     * @callback module:api/StrategicProgramApi~strategicProgramLoadManyPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicProgramReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMany
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {module:api/StrategicProgramApi~strategicProgramLoadManyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicProgramReport>}
     */
    this.strategicProgramLoadManyPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramLoadManyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramLoadManyPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicProgramReport];

      return this.apiClient.callApi(
        '/StrategicProgram/loadMany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
